export const VIDEO_SESSION_HEARTBEAT_INTERVAL_MS = 30000; // 30 seconds

export const VIDEO_CHAT_WEB_PANEL_WIDTH = 400;
